// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getLinkLabelVm(data) {
  return {
          link: data.link,
          label: data.label
        };
}

function getLinksVm(data) {
  var link = data.for_enterprise_link;
  var link$1 = data.api_integration_link;
  return {
          driver_partner_link: getLinkLabelVm(data.driver_partner_link),
          support_link: getLinkLabelVm(data.support_link),
          refund_policy_link: getLinkLabelVm(data.refund_policy_link),
          terms_of_service_link: getLinkLabelVm(data.terms_of_service_link),
          for_enterprise_link: !(link == null) ? getLinkLabelVm(link) : undefined,
          api_integration_link: !(link$1 == null) ? getLinkLabelVm(link$1) : undefined
        };
}

function getMenuVm(data) {
  return {
          close_icon: data.menu_close_icon,
          open_icon: data.menu_open_icon,
          links: getLinksVm(data)
        };
}

function getComponayInfoVm(data) {
  return {
          company_info: data.company_info,
          links: getLinksVm(data),
          location_icon: data.location_icon
        };
}

function getCardVm(data) {
  return {
          title: data.title,
          desc: data.desc,
          icon: data.icon
        };
}

function getOpenAppVm(data) {
  return {
          app_action: getLinkLabelVm(data.open_app_card.app_action),
          card: getCardVm(data.open_app_card.card),
          close_icon: data.menu_close_icon
        };
}

function getVm(data) {
  return {
          links: getLinksVm(data),
          logo: data.logo,
          menu_content: getMenuVm(data),
          company_content: getComponayInfoVm(data),
          open_app_content: getOpenAppVm(data)
        };
}

function countOfLiveOrder(history) {
  if (typeof history === "number" || history.TAG !== /* Live */1) {
    return 0;
  } else {
    return history._0.length;
  }
}

function orderCrn(history, index) {
  if (typeof history === "number") {
    return "";
  }
  if (history.TAG !== /* Live */1) {
    return "";
  }
  var orders = history._0;
  if (orders.length > 0) {
    return Caml_array.get(orders, index).order_crn;
  } else {
    return "";
  }
}

function isCourierOrder(history, index) {
  if (typeof history === "number") {
    return false;
  }
  if (history.TAG !== /* Live */1) {
    return false;
  }
  var orders = history._0;
  if (orders.length > 0) {
    return Caml_array.get(orders, index)._type === /* Courier */3;
  } else {
    return false;
  }
}

function getMenuLinks(links, isDom) {
  if (isDom) {
    return [
            Belt_Option.getWithDefault(links.api_integration_link, {
                  link: "",
                  label: ""
                }),
            links.driver_partner_link,
            links.support_link,
            Belt_Option.getWithDefault(links.for_enterprise_link, {
                  link: "",
                  label: ""
                })
          ];
  } else {
    return [
            links.support_link,
            links.driver_partner_link,
            links.refund_policy_link,
            links.terms_of_service_link
          ];
  }
}

var right_arrow = {
  src: "https://dom-content-vault-prod-cdn-assets.porter.in/chevron_right_black_a88c53ca36/chevron_right_black_a88c53ca36.svg",
  width: 24.0,
  height: 24.0,
  alt: "Right Arrow Icon"
};

export {
  getLinkLabelVm ,
  getLinksVm ,
  getMenuVm ,
  getComponayInfoVm ,
  getCardVm ,
  getOpenAppVm ,
  getVm ,
  right_arrow ,
  countOfLiveOrder ,
  orderCrn ,
  isCourierOrder ,
  getMenuLinks ,
}
/* No side effect */
